import tms from "./tms";

export default {
  namespaced: true,
  modules: {
    tms,
  },
};
